import { render, staticRenderFns } from "./MenuFormulaire.vue?vue&type=template&id=1b38edb2&"
import script from "./MenuFormulaire.vue?vue&type=script&lang=js&"
export * from "./MenuFormulaire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports